var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNucleuscareTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 45,
    viewBox: "0 0 51 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5079 29.649C23.1435 27.2604 19.0253 24.5693 19.0253 20.9706C18.9783 17.3719 23.394 16.1458 25.5079 19.633C27.6688 16.1458 31.9906 17.3241 31.9906 20.9706C31.9906 24.5693 27.8567 27.2604 25.5079 29.649Z",
    fill: "url(#paint0_linear_648_4229)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5234 35.3819C27.9661 35.3819 30.3932 34.6813 32.5071 33.2641C37.1421 30.1431 39.256 24.2036 37.6588 18.7896C37.3926 17.866 36.4374 17.3405 35.5292 17.6271C34.621 17.8978 34.1043 18.8692 34.3862 19.7927C35.5449 23.7418 34.0103 28.0889 30.6281 30.366C27.2458 32.6431 22.7049 32.3883 19.5888 29.745C18.8685 29.124 17.7724 29.2354 17.1774 29.9679C16.5667 30.7004 16.6763 31.815 17.3966 32.4201C19.7141 34.3787 22.6109 35.3819 25.5234 35.3819Z",
    fill: "url(#paint1_radial_648_4229)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3874 14.6332C23.7697 12.3561 28.3107 12.6109 31.4267 15.2542C32.1627 15.8752 33.2431 15.7637 33.8381 15.0312C34.4488 14.2828 34.3392 13.1841 33.6189 12.579C29.3441 8.96436 23.1277 8.61404 18.4927 11.7351C13.8578 14.8561 11.7439 20.7956 13.3411 26.2096C13.5603 26.958 14.2492 27.4516 14.9852 27.4516C15.1418 27.4516 15.314 27.4357 15.4706 27.372C16.3788 27.1013 16.8955 26.13 16.6137 25.2064C15.4706 21.2574 17.0052 16.9102 20.3874 14.6332Z",
    fill: "url(#paint2_radial_648_4229)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.742 10.3026C10.147 11.051 10.2722 12.1497 11.0082 12.7548C11.3214 13.0096 11.6972 13.137 12.073 13.137C12.5741 13.137 13.0751 12.914 13.4196 12.4841C16.2851 8.83762 20.5443 6.64016 25.1166 6.48093C29.6732 6.32169 34.089 8.20067 37.205 11.6242C37.847 12.3249 38.9275 12.3726 39.6321 11.7198C40.3211 11.0669 40.368 9.96819 39.726 9.25163C35.9367 5.06373 30.5658 2.77074 25.007 2.97774C19.4325 3.20067 14.2339 5.85991 10.742 10.3026Z",
    fill: "url(#paint3_radial_648_4229)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1558 3.23044C14.9701 2.73681 15.2363 1.66993 14.7509 0.841904C14.2654 0.0138789 13.2163 -0.256822 12.4021 0.236809C2.58414 6.20815 -2.12909 18.2145 0.924331 29.4247C1.12789 30.189 1.81687 30.6986 2.56848 30.6986C2.72507 30.6986 2.88165 30.6827 3.02258 30.6349C3.93078 30.3801 4.46317 29.4088 4.21263 28.4852C1.58199 18.7878 5.66888 8.4056 14.1558 3.23044Z",
    fill: "url(#paint4_radial_648_4229)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41999 34.6974C6.31037 34.5222 6.20077 34.3471 6.09116 34.1719C5.57442 33.3598 4.5253 33.121 3.72671 33.6464C2.92812 34.1719 2.69324 35.2388 3.20998 36.0509C3.33524 36.242 3.44485 36.4171 3.57012 36.6082C3.66407 36.7675 3.78934 36.8948 3.93027 37.0063C4.49398 37.4681 5.30823 37.5318 5.95023 37.1019C6.7175 36.5764 6.93672 35.5095 6.41999 34.6974Z",
    fill: "url(#paint5_radial_648_4229)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8662 9.12431L46.5373 9.10838C45.5822 9.07654 44.7992 9.84087 44.7679 10.7963C44.7366 11.7517 45.4882 12.5638 46.4277 12.5956L46.7722 12.6116C46.7879 12.6116 46.8035 12.6116 46.8192 12.6116C47.743 12.6116 48.5103 11.8632 48.526 10.9077C48.5573 9.93641 47.8213 9.14023 46.8662 9.12431Z",
    fill: "url(#paint6_radial_648_4229)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0761 15.572C49.8256 14.6484 48.8704 14.107 47.9622 14.3618C47.054 14.6166 46.5216 15.5879 46.7722 16.5115C49.4185 26.2089 45.3316 36.5911 36.8446 41.7662C36.0304 42.2599 35.7642 43.3268 36.2496 44.1548C36.5784 44.6962 37.1422 44.9987 37.7215 44.9987C38.019 44.9987 38.3165 44.9191 38.5984 44.744C48.4163 38.7726 53.1296 26.7822 50.0761 15.572Z",
    fill: "url(#paint7_radial_648_4229)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7522 21.7194C44.6739 19.506 44.2355 17.3404 43.4369 15.3022C43.0924 14.4105 42.0903 13.9646 41.2134 14.3149C40.3365 14.6653 39.8981 15.6844 40.2426 16.5761C40.9002 18.2481 41.2604 20.0315 41.323 21.8468C41.5892 29.522 36.4375 36.2895 29.078 37.9614C28.1541 38.1685 27.5748 39.1079 27.7783 40.0474C27.9506 40.8595 28.6709 41.4169 29.4538 41.4169C29.5791 41.4169 29.7043 41.4009 29.8296 41.3691C38.802 39.3149 45.0811 31.0665 44.7522 21.7194Z",
    fill: "url(#paint8_radial_648_4229)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0966 41.6234C23.9265 41.6234 24.6625 41.0023 24.7877 40.1425C24.9287 39.187 24.2867 38.2953 23.3471 38.1679C15.8937 37.0374 10.2879 30.6361 10.0217 22.9769C9.95905 21.1616 10.1939 19.3622 10.7263 17.6425C11.0082 16.7189 10.5071 15.7316 9.5989 15.445C8.69071 15.1584 7.73553 15.6679 7.45368 16.5915C6.79602 18.6934 6.51416 20.8749 6.59246 23.0883C6.92129 32.4355 13.7484 40.2221 22.8461 41.6074C22.9244 41.6234 23.0026 41.6234 23.0966 41.6234Z",
    fill: "url(#paint9_radial_648_4229)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_648_4229",
    x1: 30.3601,
    y1: 25.4684,
    x2: 19.531,
    y2: 18.1877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_648_4229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5001 46.9687) rotate(180) scale(37.3064 37.9377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#E4C437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7966,
    stopColor: "#EBF2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_648_4229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5001 46.9683) rotate(180) scale(37.3064 37.9377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#E4C437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7966,
    stopColor: "#EFEFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_648_4229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5004 46.969) rotate(180) scale(37.3064 37.9377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#E4C437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7966,
    stopColor: "#EFEFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_648_4229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5006 46.9669) rotate(180) scale(37.3064 37.9377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#E4C437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7966,
    stopColor: "#EBF2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_648_4229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4963 23.4003) rotate(-140.581) scale(37.5563 37.6836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#E4C437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7966,
    stopColor: "#EFEFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_648_4229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5227 -34.363) rotate(180) scale(37.3064 37.9378)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#E4C437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7966,
    stopColor: "#EBF2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_648_4229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5002 46.9677) rotate(180) scale(37.3064 37.9377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#E4C437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7966,
    stopColor: "#EFEFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_648_4229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5002 46.9686) rotate(180) scale(37.3064 37.9377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#E4C437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7966,
    stopColor: "#EFEFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_648_4229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5003 46.9681) rotate(180) scale(37.3064 37.9377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#E4C437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7966,
    stopColor: "#EFEFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNucleuscareTransparent);
export default __webpack_public_path__ + "static/media/nucleuscare-transparent.bc205ce95bc02fc7e9177561dd731845.svg";
export { ForwardRef as ReactComponent };